<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="end">
      <ion-button (click)="openInformationModal()" class="header--button-close">
        <ion-icon name="information-circle"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{title}}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content fullscreen>
  <form [formGroup]="registerForm" (ngSubmit)="submitForm()">
    <h4 class="auth-label">Mobile Number</h4>
      <ngx-intl-tel-input
        [cssClass]="'auth-input'"
        class="auth-input-wrapper"
        [preferredCountries]="[CountryIso.Australia, CountryIso.NewZealand]"
        [selectedCountryISO]="selectedCountryISO"
        [enableAutoCountrySelect]="true"
        [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
        [enablePlaceholder]="true"
        [searchCountryFlag]="true"
        [maxLength]="15"
        [phoneValidation]="true"
        name="phone"
        formControlName="phone"
        #phoneNumberInput
      >
      </ngx-intl-tel-input>
      <p class="form-error" style="padding-left: 1rem;" *ngIf="!registerForm.valid && errorMessage">{{ errorMessage }}</p>
    <ion-grid>
      <ion-row>
      </ion-row>
      <input type="hidden" formControlName="site" />
      <ion-row>
        <ion-col size="6">
          <ion-item lines="none">
            <ion-label class="auth-button-label" position="stacked">First name</ion-label>
            <ion-input type="text" formControlName="first" color="input-text" #firstName></ion-input>
            <control-label [control]="registerForm.controls['first']" fieldName="First name"></control-label>
          </ion-item>
        </ion-col>
        <ion-col size="6">
          <ion-item lines="none">
            <ion-label class="auth-button-label" position="stacked">Last name</ion-label>
            <ion-input type="text" formControlName="last" color="input-text"></ion-input>
            <control-label [control]="registerForm.controls['last']" fieldName="Last name"></control-label>
          </ion-item>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="6">
          <ion-item lines="none" [ngClass]="registerForm.controls['gender'] | itemClassFix">
            <ion-label class="auth-button-label" position="stacked">Gender</ion-label>
            <ion-select formControlName="gender" interface="popover" placeholder="Select gender">
              <ion-select-option *ngFor="let gender of genders" value="{{gender.value}}">{{gender.valueText}}</ion-select-option>
            </ion-select>
            <control-label [control]="registerForm.controls['gender']" fieldName="Gender"></control-label>
          </ion-item>
        </ion-col>
        <ion-col size="6">
          <ion-item lines="none" [ngClass]="registerForm.controls['dob'] | itemClassFix">
            <ion-label class="auth-button-label" position="stacked">Date of birth</ion-label>
            <app-date-input formControlName="dob" [maxDate]="maxDateStr"></app-date-input>
            <control-label [control]="registerForm.controls['dob']" fieldName="Date of birth"></control-label>
          </ion-item>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</ion-content>

<ion-footer class="auth-footer">
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-button expand="block" (click)="cancel()" class="auth-button secondary">Cancel</ion-button>
        </ion-col>
        <ion-col>
          <ion-button expand="block" (click)="submitForm()" [disabled]="!registerForm.valid" class="auth-button primary">Register
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
</ion-footer>